import { Injectable } from '@angular/core';

@Injectable()
export class IdGeneratorService {
  next = () => new Date().getTime().toString(36);
}